<template>
  <div>
     
        <div class="pull-rights ui-mt-50 pull-right">
            <div class="dropdown display-flex-inline">

                <!-- Actions -->
                <div class="dropdown ui-mr5">
                                    
                    <button type="button" 
                        class="btn btn-danger btn-sm dropdown-toggle" 
                        data-toggle="dropdown"
                        aria-haspopup="true" 
                        aria-expanded="false" 
                        :disabled="bulkLoading">
                        <span v-if="!bulkLoading">Bulk Actions</span>
                        <span v-if="bulkLoading">
                            <span class="spinner-grow spinner-grow-sm mr-1" 
                                    role="status" 
                                    aria-hidden="true">
                            </span>Loading...
                        </span>
                    </button>

                    <div class="dropdown-menu">
                        <a v-if="(permissions.edit) && (status == 'inactive' || status == '')"
                            @click="multiActive()"
                            class="dropdown-item" 
                            href="javascript:;">Active
                        </a>
                        <a v-if="(permissions.edit) && (status == 'active' || status == '')"
                            @click="multiInactive()"
                            class="dropdown-item" 
                            href="javascript:;">Inactive
                        </a>

                        <a v-if="permissions.delete && status != 'trash'"
                            @click="multiMoveToTrash()"
                            class="dropdown-item" 
                            href="javascript:;">Move to Trash
                        </a>

                        <a v-if="permissions.delete && status == 'trash'"
                            @click="multiRestoreFromTrash()"
                            class="dropdown-item" 
                            href="javascript:;">Restore
                        </a>
                        <a v-if="permissions.delete && status == 'trash'"
                            @click="multiDeletePermanently()"
                            class="dropdown-item" 
                            href="javascript:;">Delete Permanently
                        </a>
                    </div>
                
                </div>
                <!-- End Actions -->

                <!-- Export -->
                <!-- <div class="dropdown">
                    <button 
                            id="dropdownMenuButton"
                            type="button" 
                            class="btn btn-secondary btn-sm dropdown-toggle" 
                            data-toggle="dropdown" 
                            aria-haspopup="true" 
                            aria-expanded="false" 
                            :disabled="loading">
                        <span v-if="!loading">Export</span>
                        <span v-if="loading">
                            <span 
                                class="spinner-grow spinner-grow-sm mr-1" 
                                role="status" 
                                aria-hidden="true">
                            </span>
                            Loading...
                        </span>
                    </button>

                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            
                        <download-excel
                                class = "dropdown-item cursor-pointer"
                                :fetch = "fetchExport"
                                :fields = "json.json_fields"
                                :before-generate = "startDownload"
                                :before-finish = "finishDownload"
                                :worksheet = "refs"
                                :name = "refs+'.xls'">Excel
                        </download-excel>

                        <download-excel
                                class = "dropdown-item cursor-pointer"
                                :fetch = "fetchExport"
                                :fields = "json.json_fields"
                                :before-generate = "startDownload"
                                :before-finish = "finishDownload"
                                type = "csv"
                                :worksheet = "refs"
                                :name = "refs+'.xls'">CSV
                        </download-excel>

                        <a class="dropdown-item" 
                                href="javascript:;" 
                                v-print="'#printMe'">Print
                        </a>
                    </div>
                    
                </div> -->
                <!-- End Export -->
            
            </div>
        </div>

  </div>
</template>

<script>
import iziToast from 'izitoast'

export default {
    name: 'BulkAction',
    props: [
        'bulkLoading', 
        'exportLoading',
        'permissions', 
        'selected',
        'fields',
        'status',
        'refs',
        'val'
    ],
    data(){
        return {
            json: {
                json_fields: this.$props.fields, 
                json_data: [],
                json_meta: [
                    [{
                        'key': 'charset',
                        'value': 'utf-8'
                    }]
                ],
            },

            loading: this.$props.exportLoading,
            ids: this.$props.selected
        }
    },
    mounted() {},
    watch: {
        selected: function(new_value) {
            this.ids = new_value
        },
        exportLoading: function(new_value) {
            this.loading = new_value
        }
    },
    created() {},
    methods: {


        async fetchExport(){
            const res = await this.axios.post(window.baseURL+'/'+this.refs+'/export?id='+this.ids);
            return res.data.rows;
        },
        startDownload(){
            this.loading = true;
        },
        
        finishDownload(){
            this.loading = false;
            iziToast.success({
                icon: 'ti-check',
                title: 'Great job,',
                message: 'File Generated Successfully',
            });
        },


        multiActive(event){
            this.$emit('activeChange', event)
        },

        multiInactive(event){
            this.$emit('inactiveChange', event)
        },
            
        multiMoveToTrash(event){
            this.$emit('trashChange', event)
        },

        multiRestoreFromTrash(event){
            this.$emit('restoreChange', event)
        },

        multiDeletePermanently(event){
            this.$emit('deleteChange', event)
        },


    }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
